import { Chip } from '@w7/ui'

export function enabledChip(enabled: boolean) {
  return (
    <Chip tone={enabled ? 'profit' : 'neutral'} size="sm">
      {enabled ? 'On' : 'Off'}
    </Chip>
  )
}

/** Lab multiple-device-ids player-chip mdi-magenta when isCheater. */
export function cheaterUsername(username: string, isCheater?: boolean) {
  return (
    <span className={isCheater ? 'cm-cheater-name' : undefined}>{username}</span>
  )
}

/** Wrap chips for device/fingerprint id columns — full values, no truncate. */
export function idChipList(ids: string[] | undefined | null) {
  if (!ids?.length) return '—'
  return (
    <div className="cm-id-chip-row">
      {ids.map((id) => (
        <Chip key={id} tone="info" size="sm" title={id}>
          {id}
        </Chip>
      ))}
    </div>
  )
}
